fragment ProductMediaFragment on ProductMedia {

    ...MediaFragment

    pivot {
        priority
    }
}